<template>
      <lr-dialog
        :dialogTitle="dialogTitle"
        :dialogVisible.sync="dialogVisible"
        :width="'600px'"
        :closeSubmit="true"
        :destroyOnClose="true"
        @cancel="cancel"
        >
        <div class="des">送审说明：{{data.AuditContent?(data.AuditContent.trim()?data.AuditContent:'无送审说明'):'无送审说明'}}</div>
        <div class="dialog-content">
            <div>
                <el-steps direction="vertical" :space="100" :active="steps.length" finish-status="process">
                    <el-step :status="filterProccessStatus(item.AuditedStatus)" :title="'审核人：'+item.AuditedUserName+'  ('+filterAuditStatus(item.AuditedStatus)+') '+((item.AuditedOpinion?item.AuditedOpinion.trim():'')?' 审核意见：'+item.AuditedOpinion:'')" v-for="(item,index) in steps" :key="index" :description="'时间：'+item.UpdateTime"></el-step>
                </el-steps>
            </div>
        </div>
        </lr-dialog>
</template>

<script>
import {documentAuditRecord } from "@/api/document.js";
export default {
  name: "AuditProcess",
  props:{
    data:{
      type: Object,
      default: {},
    }
  },
  watch:{
    data: {
      handler: function (n, o) {
        if(n!=o){
          this.loadData(n)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
  },
  mounted() {
  },
  data() {
    return {
      dialogTitle:'审核流程',
      dialogVisible:true,
      steps:[],
    };
  },
  methods: {
      filterAuditStatus(val){
          if(val==1){
              return '待审核'
          }else if(val==3){
              return '不通过'
          }else if(val==4){
              return '通过'
          }
      },
      filterProccessStatus(val){
          if(val==1){
              return 'process'
          }else if(val==3){
              return 'error'
          }else if(val==4){
              return 'success'
          }
      },
    loadData(data){
      documentAuditRecord({docid:data.DocID?data.DocID:data.ID}).then((res) => {
        if (res.Code === 200) {
            this.steps =res.Data.reverse()
        }
      })
    },
    cancel(){
      this.$emit('closeCallback')
    }
  },
};
</script>
<style scoped  lang="scss">
.des{
  font-size: 18px;
    /* font-weight: bold; */
        color: #303133;
    margin-bottom: 20px;
}
.dialog-content{
  max-height:300px;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/document/components/AuditProcess.vue